<template>
   <div class="container-wrapper" v-loading="loading">
      <div class="breadcrumb-wrapper">公告管理</div>

      <!-- <div class="search-wrapper">
         <el-select style="width: 400px; margin-left: 20px" placeholder="请输入高校或校区名称" filterable clearable
            v-model="paramData.unid" @change="queryAnnouncements">
            <el-option v-for="item in zoneOptions" :value="item.unid" :key="item.unid" :label="item.name"></el-option>
         </el-select>
      </div> -->

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData" style="width: 100%">
            <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
            <el-table-column align="center" prop="title" label="标题" width="300"></el-table-column>
            <el-table-column align="center" label="涉及学校" inline-template>
               <span>{{ row.applicableCampus == 0 ? "全部" : row.countCampus }}</span>
            </el-table-column>
            <el-table-column align="center" label="状态" inline-template>
               <span>{{ row.status == 2 ? "已发布" : "草稿" }}</span>
            </el-table-column>
            <el-table-column align="center" label="最新操作时间" inline-template>
               <span>{{ new Date(row.updateTime).format("yyyy-MM-dd hh:mm:ss") }}</span>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200" inline-template>
               <span>
                  <el-button type="text" size="small" @click="clickEdit(row)">编辑</el-button>
                  <el-button type="text" size="small" v-if="row.status == 1" @click="clickRelease(row)">发布</el-button>
                  <el-button type="text" size="small" v-if="row.status == 2" @click="clickRevoke(row)">撤销发布</el-button>
                  <el-button type="text" size="small" v-if="row.status == 1" @click="clickDelete(row)">删除</el-button>
               </span>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="paramData.pageNum"
            :page-size='paramData.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         zoneOptions: [],
         paramData: {
            unid: "",
            pageNum: 1,
            pageSize: 20,
         },
         listData: [],
         total: 0,
      }
   },

   mounted() {
      // this.queryCampusZones();
      this.queryAnnouncements();
   },

   methods: {
      // 获取所有校区
      queryCampusZones() {
         this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v1/basicTools/allCampusZones",
         }).then((response) => {
            if (response.data.error == 10000) {
               this.zoneOptions = response.body.data;
            } else {
               this.$util.errorMsg(response.data.message);
            }
         });
      },

      // 获取公告列表
      queryAnnouncements() {
         this.loading = true;
         this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v1/announcement/list",
            params: {
               // unid: this.paramData.unid,
               pageSize: this.paramData.pageSize,
               pageNum: this.paramData.pageNum,
            },
         }).then((response) => {
            if (response.data.error == 10000 && JSON.stringify(response.body.data) !== "{}") {
               this.listData = response.body.data.annoListDTOS;
               this.total = response.body.data.count
            } else {
               this.listData = [];
               this.$util.errorMsg(response.data.message);
            }
         }).catch((error) => {
            this.listData = [];
            this.$util.errorMsg(error.message);
         }).finally(() => {
            this.loading = false;
         });
      },

      // 发布或撤销
      updateReleaseAndRevoke(id, status) {
         this.loading = true;
         this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v1/announcement/changestatus",
            params: {
               id: id,
               status: status,
            },
         }).then((response) => {
            if (response.data.error == 10000) {
               this.$util.successMsg(status == 2 ? "发布成功" : "撤销成功");
               this.queryAnnouncements();
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).catch((error) => {
            this.$util.errorMsg(error.message);
         }).finally(() => {
            this.loading = false;
         });
      },

      // 删除
      sendDelete(id) {
         this.loading = true;
         this.$http({
            method: "GET",
            url: this.$util.domain + "/adminapi/v1/announcement/delete",
            params: {
               id: id,
            }
         }).then((response) => {
            if (response.data.error == 10000) {
               this.$util.successMsg("删除成功");
               this.queryAnnouncements();
            } else {
               this.$util.errorMsg(response.data.message);
            }
         }).catch((error) => {
            this.$util.errorMsg(error.message);
         }).finally(() => {
            this.loading = false;
         });
      },

      // 点击新增公告
      clickAddition() {
         // location.href = "/#/xiaoyuan/GX/announcement/announcementDetail";
         location.href = "/#/xiaoyuan/announcement/detail";
      },

      // 点击编辑
      clickEdit(row) {
         // location.href = `/#/xiaoyuan/GX/announcement/announcementDetail?id=${row.id}`;
         location.href = `/#/xiaoyuan/announcement/detail?id=${row.id}`;
      },

      // 点击发布
      clickRelease(row) {
         this.$confirm('确定要发布吗？', '发布', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.updateReleaseAndRevoke(row.id, 2);
         }).catch(() => { })
      },

      // 点击撤销发布
      clickRevoke(row) {
         this.$confirm('确定要撤销发布吗？', '撤销', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.updateReleaseAndRevoke(row.id, 1);
         }).catch(() => { })
      },

      // 点击删除
      clickDelete(row) {
         this.$confirm('确定要删除吗？', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(() => {
            this.sendDelete(row.id);
         }).catch(() => { })
      },

      // 点击页码
      changeCurrentPage(val) {
         this.paramData.pageNum = val;
         this.queryAnnouncements();
      },
   }
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// Announcement.vue?335dedd6